import { TFunction } from 'next-i18next';
import * as yup from 'yup';

export function checkIfFilesAreCorrectType(file?: File): boolean {
  let valid = true;
  if (file) {
    if (
      ![
        'image/jpeg',
        'image/png',
        'image/jpg',
        'image/svg',
        'image/webp',
      ].includes(file.type)
    ) {
      valid = false;
    }
  }
  return valid;
}

export const yupValidationsShape = (t: TFunction) => {
  return {
    expenseType: yup.string().optional(),
    cropId: yup.number().required(t('required-right-data')),
    amount: yup
      .string()
      .matches(/^\d*(\.\d+)?$/, { message: t('required-right-data') })
      .required(t('required-right-data')),
    // attachment: yup
    //   .mixed()
    //   .test(
    //     'is type correct',
    //     t('require-only-images'),
    //     checkIfFilesAreCorrectType
    //   )
    //   .required(t('required-data')),
    // note: yup
    //   .string()
    //   .min(3, `${t('minimum')} 3`)
    //   .max(500, `${t('maximum')} 500`)
    //   .notRequired(),
  };
};
